let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1fhs0")).then(() => parcelRequire('4BxD7'));